import { render, staticRenderFns } from "./ImportExportDropdownMenu.vue?vue&type=template&id=51d24351&"
import script from "./ImportExportDropdownMenu.vue?vue&type=script&lang=ts&"
export * from "./ImportExportDropdownMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports